export default {
  black: '#3C3C3C',
  translucentBlack: 'rgba(0, 0, 0, 0.6)',
  green: '#00A5A0',
  gray: '#989898',
  lightGray: '#D0D0D0',
  activeGreen: '#039AA7',
  red: '#FF5A5F',
  dangerRed: '#FF3B3B',
  orange: '#FF8C00',
  white: '#FFFFFF',
  fontFamily: '"Airbnb Cereal App", sans-serif',
};
